<template>
  <v-dialog
    v-bind:content-class="contentClass"
    v-bind:max-width="maxWidth"
    v-bind:width="width"
    v-bind:persistent="persistent"
    v-bind:scrollable="scrollable"
    v-bind:value="value"
    v-on:input="onInput"
    v-on:click:outside="onClickOutside"
  >
    <v-card class="modal-dialog-bonus-card" v-bind:class="{ scrollable: scrollable }">
      <v-card-text class="pb-0 justify-center">
        <slot />
      </v-card-text>
      <button
        v-on:click="closeByCross"
        type="button"
        class="modal-dialog-bonus-card__cross"
      />
    </v-card>
  </v-dialog>
</template>

<script>

/**
 * @description Название событие ввода.
 * @type {string}
 */
const NAME_EVENT_INPUT = 'input';

/**
 * @description Название событие клик снаружи модального окна.
 * @type {string}
 */
const ON_CLICK_OUTSIDE = 'on-click-outside';

export default {
  /**
   * @description Модальное окно бонусной карты
   */
  name: 'ModalDialogBonusCard',
  methods: {
    /**
     * Закрыть по нажатию на background
     * @returns {void}
     */
    onClickOutside() {
      this.$emit(ON_CLICK_OUTSIDE);
    },
    /**
     * Закрытие по нажатию крестика.
     * @returns {void}
     */
    closeByCross() {
      this.$emit(NAME_EVENT_INPUT, false);
    },
    /**
     * @description Обработать ввод.
     * @param {boolean} isShown
     * @returns {void}
     */
    onInput(isShown) {
      this.$emit(NAME_EVENT_INPUT, isShown);
    },
  },
  props: {
    /**
     * @description Пользовательский класс.
     * @type {string}
     */
    contentClass: { default: undefined, type: String },
    /**
     * @description Максимальная ширина.
     * @type {string}
     */
    maxWidth: { default: () => 'fit-content', type: String },
    /**
     * @description Фиксированная ширина.
     * @type {string}
     */
    width: { default: () => 'fit-content', type: String },
    /**
     * @description Предотвращать закрытие диалога при
     * клике за пределами элемента или при нажатии esc.
     * @type {boolean}
     */
    persistent: { default: () => false, type: Boolean },
    /**
     * @description Прокручиваемый.
     * @type {boolean}
     */
    scrollable: { default: () => false, type: Boolean },
    /**
     * @description Показывать диалог.
     * @type {Boolean}
     */
    value: { required: true, type: Boolean },
  },
};

</script>

<style lang="scss" scoped>

::v-deep .v-dialog:not(.v-dialog--fullscreen) {
  &.position-start {
    align-self: flex-start;
  }
}

.modal-dialog-bonus-card {
  padding: 20px;
  &__title {
    margin-bottom: 10px !important;
    &--center {
      text-align: center;
    }
    &--large {
      font-size: 26px;
      @media screen and (max-width: 768px) {
        font-size: 24px;
      }
      @media screen and (max-width: 480px) {
        font-size: 20px;
      }
    }
  }
  &.scrollable {
    overflow: hidden;
  }
  .v-card__title {
    word-break: break-word;
  }
  .v-card__text {
    display: grid;
    grid-template-columns: 1fr;
    row-gap: 15px;
  }
  &__previous-button {
    color: var(--action-color);
    display: flex;
    align-items: center;
    gap: 7px;
    margin: 0 0 10px 0;
    &:before {
      content: '';
      background-image: url('@/assets/img/arrow/arrow-blue.svg');
      background-position: center;
      background-size: contain;
      width: 12px;
      height: 12px;
      display: block;
    }
    &:hover {
      text-decoration: underline;
    }
  }
  &__cross {
    position: absolute;
    right: 15px;
    top: 15px;
    cursor: pointer;
    background-image: url("@/assets/img/exit-black.svg");
    background-repeat: no-repeat;
    background-size: contain;
    width: 17px;
    height: 17px;
  }
}

@media screen and (max-width: 620px) {
  .modal-dialog-bonus-card {
    padding: 20px 10px;
  }
}
</style>
